import posed from "react-pose";
import { styled } from "@lib/components";

const DEFAULT_BG_IMAGE =
	"https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=1200&auto=format&fit=crop&q=80";

const Shell = styled("div")`
	min-height: 100vh;
	min-height: 100dvh;
	box-sizing: border-box;
	padding: var(--cw-safe-top, 0px) var(--cw-safe-right, 0px) var(--cw-safe-bottom, 0px) var(--cw-safe-left, 0px);
	display: flex;
	overflow: hidden;
	background: #f1f4f7;
`;

const LeftPanel = styled("div")`
	display: none;
	position: relative;
	overflow: hidden;

	@media (min-width: 1024px) {
		display: flex;
		width: 50%;
	}
`;

const LeftImage = styled("img")`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
`;

const LeftOverlay = styled("div")<{ bg_tint?: string }>`
	position: absolute;
	inset: 0;
	background: ${(props) => props.bg_tint || "rgba(15, 23, 42, 0.3)"};
`;

const LeftFooter = styled("div")`
	position: absolute;
	bottom: 24px;
	left: 24px;
	color: white;
	font-size: 14px;
	opacity: 0.75;
	z-index: 1;
`;

const MainPose = posed.div({
	visible: {
		opacity: 1,
		translateY: 0,
	},
	hidden: {
		opacity: 0,
		translateY: 14,
	},
});

const RightPanel = styled(MainPose)<{ boxStyle?: string }>`
	flex: 1;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	overflow: hidden;
	padding: 0;
	background: #f1f4f7;
	min-height: 100vh;
	min-height: 100dvh;

	@media (min-width: 640px) {
		justify-content: center;
		padding: ${(props) => (props.boxStyle === "expanded" ? "40px 32px" : "40px 24px")};
	}

	@media (min-width: 1024px) {
		justify-content: center;
	}
`;

const FrostBg = styled("div")<{ bgImage: string }>`
	pointer-events: none;
	position: absolute;
	inset: 0;
	background-image: url(${(props) => props.bgImage});
	background-size: cover;
	background-position: center;
	transform: scale(1.05);
	filter: blur(5px);
`;

const FrostOverlay = styled("div")`
	pointer-events: none;
	position: absolute;
	inset: 0;
	background: rgba(255, 255, 255, 0.60);
	backdrop-filter: blur(16px);
	-webkit-backdrop-filter: blur(8px);
`;

const Content = styled("div")`
	position: relative;
	z-index: 10;
	width: 100%;
	max-width: 428px;
	display: flex;
	flex-direction: column;
	gap: 32px;
	padding: 40px 40px 24px;
	box-sizing: border-box;
`;

const LogoHeader = styled("div")`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	gap: 12px;

	img {
		height: 84px;
		width: auto;
		max-width: 100%;
		max-height: 84px;
		object-fit: contain;
	}
`;

const LogoTitle = styled("div")`
	font-size: 16px;
	font-weight: 700;
	color: #000000;
	line-height: 1.2;
`;

const LogoSubtitle = styled("div")`
	font-size: 14px;
	font-weight: 400;
	color: #000000;
	line-height: 24px;
	margin-top: 2px;
`;

const ContentBox = styled("div")`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 32px;
	width: 100%;
`;

export const AuthLayoutComponents = {
	Shell,
	LeftPanel,
	LeftImage,
	LeftOverlay,
	LeftFooter,
	RightPanel,
	FrostBg,
	FrostOverlay,
	Content,
	LogoHeader,
	LogoTitle,
	LogoSubtitle,
	ContentBox,
	DEFAULT_BG_IMAGE,
};
